import $ from 'jquery';
import Parsley from 'parsleyjs';

import 'parsleyjs/dist/i18n/nl';
import 'parsleyjs/dist/i18n/de';

const parsleyConfig = {
    errorClass: 'is-error',
    excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]',
    successClass: 'is-success',
};

const lang = document.documentElement.lang === 'nl_be' ? 'nl' : document.documentElement.lang

Parsley.addMessages('nl', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
}).setLocale(lang);

Parsley.addValidator('captchaValidation', {
    validateString: function (value) {
        return value.length > 0;
    },
    messages: {nl: 'Dit veld is verplicht'}
});

$('form:not([novalidate])').parsley(parsleyConfig);

// Custom validation for Google Recaptcha in Salesforce Web-to-lead forms

// 1. Each form element needs to have data-form attribute containing the unique identifier
// Example: data-form="form3"

// 2. Each form needs to have a hidden input with 'captcha_settings' (check 'orgId' for correct Salesforce id). For example:
// <input type=hidden required="required" name='captcha_settings' value='{"keyname":"WebToCaseNL","fallback":"true","orgId":"00D09000001J7Ur","ts":""}'>

// 3. Each form needs to have some HTML markup with a unique identifier for rendering the Recaptcha. Example:
// <div class="form-row-wrapper col-12 pt-4">
//     <div id="g-recaptcha-3" data-captcha="g-recaptcha-3"></div>
//     <div id="g-recaptcha-errors-3" name="g-recaptcha-errors"></div>
// </div>

window.CaptchaCallback = function() {
    // Render a Recaptcha instance for every form that has the necessary markup
    const allCaptchas = document.querySelectorAll('[data-captcha]');
    allCaptchas.forEach((captchaEl) => {
        const elId = captchaEl.getAttribute('data-captcha');
        if (elId !== null) {
            grecaptcha.render(elId, {'sitekey' : '6LcsPOMnAAAAAHD88-PPd0vmO0aBXobvvx3NOTAg'}) // eslint-disable-line no-undef
        }
    })
};

// stella.qlico key: 6LdztucnAAAAAMQ1LRCK-3XkWq0qEq2hheK0_dHM
// stella.nl key: 6LcsPOMnAAAAAHD88-PPd0vmO0aBXobvvx3NOTAg

const allForms = document.querySelectorAll('form');
let scriptLoaded = false;

// Interval is necessary to check if the Recaptcha is still valid after the user checked is (it wil invalidate after a while). If invalid then Parsley needs to be reconfigured.
allForms.forEach((form) => {
    if (form.getAttribute('data-form') !== null && form.querySelector('[name="captcha_settings"]') !== null) {
        // Only load script once and execute 'CaptchaCallback
        if (!scriptLoaded) {
            $.getScript('//www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit');
            scriptLoaded = true;
        }

        setInterval(() => {
            const response = form.querySelector('[name="g-recaptcha-response"]');
            if (response) {
                if (response.value.trim() === "") {
                    const elems = JSON.parse(form.querySelector('[name="captcha_settings"]').value);elems["ts"] = JSON.stringify(new Date().getTime());
                    form.querySelector('[name="captcha_settings"]').value = JSON.stringify(elems);
                    if (response.getAttribute('data-parsley-captcha-validation') === null) {
                        addCaptchaValidation(form)
                    }
                }
            }
        }, 1000)
    }
})

// Add Parlsey validation to Recaptcha
const addCaptchaValidation = function(form) {
    $(form).parsley().destroy();
    const formRecaptchaResponse = form.querySelector('[name="g-recaptcha-response"]');
    const formRecaptchaErrorId = form.querySelector('[name="g-recaptcha-errors"]').getAttribute('id');
    formRecaptchaResponse.setAttribute('required', true);
    formRecaptchaResponse.setAttribute('data-parsley-captcha-validation', true);
    formRecaptchaResponse.setAttribute('data-parsley-error-message', "Dit veld is verplicht.");
    formRecaptchaResponse.setAttribute('data-parsley-errors-container', `#${formRecaptchaErrorId}`);
    $(form).parsley(parsleyConfig);
}
